import { Pipe, PipeTransform } from '@angular/core';
import { BrandingService } from 'app/main/pages/settings/branding/branding.service';
import { ProductlibraryService } from 'app/main/pages/settings/productlibrary/productlibrary.service';
import { DocumentsTabService } from 'app/main/signing-pages/signing-sidebar/documents-tab/documents-tab.service';
import { environment } from 'environments/environment';

@Pipe({
  name: 'thumbnail'
})
export class ThumbnailPipe implements PipeTransform {
  constructor(private brandingService: BrandingService, private documentsService: DocumentsTabService, private productLibraryService: ProductlibraryService) { }
  transform(id: number, route: string, path: string = ''): string {
    if (route === 'brands') {
      return this.brandingService.getBrandingImagesPath(path ,id);
    } else if(route === 'chat_attachment'){
      return this.documentsService.getChatAttachmentPath(path ,id);
    } else if(route === 'product'){
      return this.productLibraryService.getProductImage(path ,id);
    }
    const routeType = route === 'galleries' ? 'stream-file' : 'thumbnailImage';
    return `${environment.apiUrl}${route}/${id}/${routeType}`;
  }

}
